/*
 Sidebar component
 url match: / or /home
 Displays overview 
*/
import { withRouter, Link } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
//import { isObjectEmpty } from '../../utils';
//import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import { withStyles } from '@material-ui/core/styles';
import { dashboardStyles } from '../../Styles/dashboardStyles';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
import UploadFilesDialog from './UploadFilesDialog'
import Dialog from '@material-ui/core/Dialog';
import FileAssignment from './FileAssignment';
import Fab from '@material-ui/core/Fab';
import CircularProgress from '@material-ui/core/CircularProgress';
import CustomCircularProgress from '../../Common/CustomCircularProgress'
import Overlay from '../../Common/Overlay';
/*const StyledDrawer = styled(Drawer)`
  & > div {
    width: 16%;
  }
`; */

const sideBarNav = [
    {
        id: 1,
        name: 'AI Pending',
        icon: 'pending',
        urlLink: '/dashboard/aiPending',
        category: ['SUPER_ADMIN']
    },
    {
        id: 2,
        name: 'Drafts',
        icon: 'navDoc',
        urlLink: '/dashboard/drafts',
        category: ['AGENT', 'ADMIN', 'SUPER_ADMIN']
    },
    {
        id: 3,
        name: 'Reviewed',
        icon: 'navReviewed',
        urlLink: '/dashboard/reviewed',
        category: ['AGENT', 'ADMIN', 'SUPER_ADMIN']
    },
    {
        id: 4,
        name: 'Exported',
        icon: 'navExported',
        urlLink: '/dashboard/exported',
        category: ['AGENT', 'ADMIN', 'SUPER_ADMIN']
    },
    {
        id: 5,
        name: 'Templates',
        icon: 'navTemplate',
        urlLink: '/dashboard/templates',
        category: ['ADMIN', 'SUPER_ADMIN']
    },

]
@inject('userStore', 'documentStore', 'commonStore', 'dashboardStore')
@observer
class Sidebar extends React.Component {

    state = {
        mobileOpen: false,
        active: '',
        openUploadDialog: false
    }


    componentDidMount() {
        this.props.userStore.getServerStatus()

        if (this.props.location.pathname.endsWith("/"))
            this.setState({
                active: this.props.location.pathname.split('/dashboard/')[1].split("/")[0]
            })
        else
            this.setState({
                active: "drafts"
            })

    }

    constructor() {
        super()
        this.inputOpenFileRef = React.createRef()
        this.zipInputFileRef = React.createRef()
    }


    handleDrawerToggle = () => {
        this.setState({
            mobileOpen: !this.state.mobileOpen
        })
    }

    openUploadDialog = () => {
        this.setState({
            openUploadDialog: true
        })
    }

    openFileModal = () => {
        this.props.dashboardStore.openFileAssign()
    }

    getCount = (type) => {
        const { countData } = this.props.dashboardStore;
        const { user } = this.props.userStore;
        if (type === 'Reviewed')
            return countData['REVIEW_COMPLETE']
        else if (type === 'Exported')
            return countData['EXPORTED']
        else if (type === 'AI Pending')
            return countData['AI_PENDING']
        else if (type === 'Drafts') {
            let temp = user.userType !== 'SUPER_ADMIN' ? countData['REVIEW_PENDING'] + countData['AI_PENDING'] : countData['REVIEW_PENDING']
            if (!isNaN(temp))
                return temp
            else
                return 0
        }
        else {
            return countData['TEMPLATE_COUNT']
        }

    }

    render() {
        const { classes } = this.props;
        const { user, isLocalTemplatePresent } = this.props.userStore;
        const { activeTab } = this.props.commonStore
        const { processingStatus } = this.props.dashboardStore;
        const { openUploadDialog } = this.state;
        const drawer = (
            <div className={classes.sidebarFlex}>
                <div>
                    <Hidden xsDown implementation="css">
                        <Link to="/">
                            <ReactSVG
                                beforeInjection={svg => {
                                    svg.classList.add(classes.svg)
                                }}
                                src={Images.logo} />
                        </Link>
                    </Hidden>
                    <div>
                        <List>
                            {sideBarNav.map((item, index) => (
                                item['category'].indexOf(user.userType) >= 0 ?
                                    <NavLink key={item.id} style={{ textDecoration: 'none', color: 'inherit' }} to={item.urlLink.toLowerCase()} onClick={this.props.dashboardStore.resumeUpdating} >
                                        <ListItem button key={item.id} style={{ padding: '0px 0px 1vh 1vw', paddingLeft: '1vw !important', height: '5vh' }}>
                                            <div style={{ display: 'flex', paddingLeft: '1vw', width: '100%' }}>
                                                <div>
                                                    <ReactSVG
                                                        beforeInjection={svg => {
                                                            svg.classList.add(classes.sideBarIcons)
                                                        }}
                                                        src={item.name.toLowerCase() === activeTab.toLowerCase() ? Images[`${item.icon}` + `Active`] : Images[`${item.icon}`]} />
                                                </div>
                                                <div style={{ color: item.name.toLowerCase() === activeTab.toLowerCase() ? this.props.theme.palette.white : this.props.theme.palette.coolGray, display: 'flex', width: '100%' }} className={classes.sideBarItems}><ListItemText classes={{ primary: classes.listItemText }} style={{ width: '100px' }} primary={item.name} /><ListItemText classes={{ primary: classes.listItemText }} primary={this.getCount(item.name)} /></div>
                                            </div>
                                        </ListItem>
                                    </NavLink> : null
                            ))}
                        </List>
                    </div>
                </div>
                <div className={classes.sidebarFooter} style={{ height: '23vh' }} >
                    {isLocalTemplatePresent ? <div className={classes.columnFlex} style={{ visibility: processingStatus.totalDocs == 0 ? 'hidden' : 'initial' }}>
                        <div className={classes.rowFLex}>
                            <CustomCircularProgress
                                strokeWidth="4"
                                sqSize="60"
                                percentage={Math.ceil(processingStatus.processedCount / processingStatus.totalDocs * 100)} />
                        </div>
                        <div className={classes.processStatus}>
                            <div>Processing files</div>
                            <div style={{ color: this.props.theme.palette.lightBlueGray, fontSize: '13px' }}>{processingStatus.processedCount}/{processingStatus.totalDocs} files</div>

                        </div>
                    </div> : null}
                    <div>
                        {user.userType != "AGENT" && isLocalTemplatePresent
                            ?
                            <Button className={classes.importButton} variant="contained" style={{ backgroundColor: this.props.theme.palette.blue }}
                                onClick={this.openFileModal}>
                                <ReactSVG style={{ marginRight: '0.5vw', marginTop: '0.5vh' }} src={Images.importDoc} />
                            Import
                        </Button> : null}
                    </div>
                    <div className={classes.trademark}>
                        © Amygb 2020
                    </div>
                </div>
            </div>

        );
        const { mobileOpen } = this.state;
        return (
            <div className={classes.sidebarContainer}>
                <CssBaseline />
                <Hidden smUp implementation="css">
                    <AppBar position="fixed" className={classes.appBar}>
                        <Toolbar>
                            <IconButton
                                aria-label="mobileOpen drawer"
                                edge="start"
                                onClick={this.handleDrawerToggle}
                                className={classes.menuButton}
                            >
                                <MenuIcon className={classes.menuIcon} />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                </Hidden>
                <nav className={classes.drawer} aria-label="navigation bar">
                    {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                    <Hidden smUp implementation="css">
                        <Drawer
                            variant="temporary"
                            open={mobileOpen}
                            onClose={this.handleDrawerToggle}
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                            ModalProps={{
                                keepMounted: true, // Better mobileOpen performance on mobile.
                            }}
                        >
                            <IconButton onClick={this.handleDrawerToggle} className={classes.closeMenuButton}>
                                <ReactSVG src={Images.logo} />
                            </IconButton>
                            {drawer}
                        </Drawer>
                    </Hidden>
                    <Hidden xsDown implementation="css">
                        <Drawer
                            className={classes.drawer}
                            variant="permanent"
                            anchor="left"
                            docked={classes.drawerPaper}
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                        >
                            {drawer}
                        </Drawer>
                    </Hidden>
                </nav>
                <FileAssignment upload={true}></FileAssignment>
                <UploadFilesDialog></UploadFilesDialog>
            </div>
        );
    }
}

export default withStyles(dashboardStyles, { withTheme: true })(withRouter(Sidebar));
